import { render, staticRenderFns } from "./CvFormDialog.vue?vue&type=template&id=70bdc85a&scoped=true"
import script from "./CvFormDialog.vue?vue&type=script&lang=js"
export * from "./CvFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CvFormDialog.vue?vue&type=style&index=0&id=70bdc85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bdc85a",
  null
  
)

export default component.exports